import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import type { ChartDataPoint } from '../../types';

interface OrderChartProps {
  data: ChartDataPoint[];
}

export const OrderChart: React.FC<OrderChartProps> = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line
          type="monotone"
          dataKey="orders"
          stroke="#1890ff"
          strokeWidth={2}
          name="Замовлення"
        />
      </LineChart>
    </ResponsiveContainer>
  );
};
